import { ErrorBox } from "@metriport/shared-internal";

export default function ErrorPage() {
  // TODO 2188 Link docs
  return (
    <ErrorBox>
      There was a bad request error during the oauth flow. Please try re-opening the app. If the
      problem persists, please reach out to support@metriport.com.
    </ErrorBox>
  );
}
